'use strict';

import jQuery from 'jquery'
import Core from './../Core/Core';

/**
 * Passport
 *
 * JavaScript functions for the general Passport pages
 */
var Activate = (function($) {
  return function (options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // If this is the activation page, do some stuff.
      if (privateNS.$container.length > 0) {

        // Add handler for the look up link.
        $('.look-up-token-link').click(function(e) {
          $('.look-up-token-form').slideDown();
        });
        
        $('.look-up-token-form').submit(function(e) {
          $('#ajax-loader-overlay').show();

          $.get('/passport/look-up-token/' + $('.look-up-token-email').val() + '/')
            .then(function(data) {
              if (data === '1') {
                Core.utils.dialog(require('./views/activationTokenSent.hbs')());
              } else {
                Core.utils.dialog(require('./views/activationTokenFailedToFind.hbs')());
              }
            })
            .catch(function() {
              Core.utils.dialog(require('./views/activationTokenUnknownError.hbs')());
            }).then(function() {
              $('#ajax-loader-overlay').hide();
            });

          e.preventDefault();
        });
      }
    };

    // Return a new instance
    return privateNS.init();
  };
})(jQuery);

export default Activate